import { gql } from '@apollo/client';

export const GET_ALL_SURROUNDING_INFORMATION_CATEGORIES_QUERY = gql`
  fragment CommonSurroundingInformationCategoryForCategoriesList on SurroundingInformationCategory {
    id
    title
    appSortOrder
    locale
    hidden
  }

  query GetAllSurroundingInformationCategories($hotelId: ID!, $limit: Int, $start: Int) {
    hotel(id: $hotelId) {
      id
      surroundingsBannerImage {
        id
        url
        formats
      }
      surroundingInformationCategories(limit: $limit, start: $start, sort: "appSortOrder:asc") {
        appSortOrder
        ...CommonSurroundingInformationCategoryForCategoriesList
        localizations {
          ...CommonSurroundingInformationCategoryForCategoriesList
        }
      }
    }
  }
`;
